import chroma from "chroma-js";

const DEFAULT_WHITE_COLOR = '#FFFFFF';

export const hexToRgba = (hex, alpha = 0.4) => {
    let hexValue = hex.replace('#', '').toLowerCase();
    if (hexValue.length === 3) {
        hexValue = hexValue.replace(/(.)/g, '$1$1');
    }
    const r = parseInt(hexValue.substring(0, 2), 16);
    const g = parseInt(hexValue.substring(2, 4), 16);
    const b = parseInt(hexValue.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const lightenColor = (sourceColorHex, luminancePercentage = 20) => {
    if (!sourceColorHex) {
        return DEFAULT_WHITE_COLOR;
    }
    
    return chroma(sourceColorHex)
      .luminance(Math.min(Math.max(0, chroma(sourceColorHex).luminance() + luminancePercentage / 100), 1))
      .hex();
}

export const darkenColor = (sourceColorHex, luminancePercentage = 15) => {
    if (!sourceColorHex) {
        return DEFAULT_WHITE_COLOR;
    }
    
    return chroma(sourceColorHex)
      .luminance(Math.min(Math.max(0, chroma(sourceColorHex).luminance() + (-1 * luminancePercentage) / 100), 1))
      .hex();
}
